<template>
  <div class="sidebar-config__summary">
    <ul class="summary-list">
      <li>
        <span>{{ $t('configurationsCount') }}</span>
        <span>
          <b>{{ totalConfigurations }}</b>
        </span>
      </li>
      <li>
        <span>{{ $t('windowsSum') }}</span>
        <span>
          <b>{{ totalWindows }} {{ $t('pieceUnit') }}</b>
        </span>
      </li>
    </ul>
    <v-button
      :content="$t('orderQuote')"
      @click="onOrderQuote"
    />
  </div>
</template>

<script>
  export default {
    name: 'SidebarSummary',
    props: {
      totalConfigurations: Number,
      totalWindows: Number,
      onOrderQuote: Function,
    },
  };
</script>
